import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { CtsProgressStore } from './core/store/cts-progress.store';
import { UtilidadesMontosProgressStore } from './core/store/utilidades-montos-progress.store';

// Declaración global para gtag (definida en index.html)
declare global {
  function gtag(...args: any[]): void;
}

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, CommonModule, ToastModule, ProgressBarModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'camposol-web-front';
  public ctsProgress = inject(CtsProgressStore);
  public utilProgress = inject(UtilidadesMontosProgressStore);

  constructor(private router: Router) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      if (typeof gtag === 'function') {
        gtag('event', 'page_view', {
          page_path: event.urlAfterRedirects
        });
      }
    });
  }

  ngOnInit(): void {
    this.ctsProgress.resumeIfActive();
    this.utilProgress.resumeIfActive();
  }
}
